import { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import ConfigurationApiContext from 'src/provider/API/v2/call-service/configuration'
import GetStartedV2 from 'src/app/dashboardv2/getStarted'

export type ChecklistStatus = 'Completed' | 'Pending'

export interface ChecklistSubTask {
    key: string
    value: {
        status: ChecklistStatus
        summary: string
    }
}

export interface ChecklistItem {
    key: string
    value: {
        status: ChecklistStatus
        summary: string
        subTasks: ChecklistSubTask[] | null
    }
}

// Onboarding counts as done once every top-level checklist item reports
// Completed. Reads the array generically rather than hardcoding step keys,
// so this stays correct if the backend adds/removes checklist items later.
const isOnboardingComplete = (checklist: ChecklistItem[]): boolean =>
    checklist.length > 0 && checklist.every((item) => item.value?.status === 'Completed')

const DashboardIndexRedirect = () => {
    const { getOnboardingChecklist } = useContext(ConfigurationApiContext)
    const [loading, setLoading] = useState(true)
    const [complete, setComplete] = useState(false)

    useEffect(() => {
        (async () => {
            const data = await getOnboardingChecklist()
            if (Array.isArray(data)) {
                setComplete(isOnboardingComplete(data as ChecklistItem[]))
            }
            setLoading(false)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loading) return null

    if (complete) {
        return <Navigate to="/dashboardv2/home" replace />
    }

    return GetStartedV2.routeProps.element
}

export default DashboardIndexRedirect